/**
 * Generated by orval 🍺
 * Do not edit manually.
 * DGA Control API
 * Sistema de monitoreo de extracción de aguas según Resolución 1238 de la DGA (Dirección General de Aguas).
 *
 * ## Protocol-level errors
 *
 * Answered to a request that is no operation of this spec, so no operation declares them. Their `type` is in `ProblemTypeEnum`.
 *
 * - `405` `/problems/method-not-allowed`: the HTTP verb is not supported on that path.
 * - `404` `/problems/not-found`: the URL matched no route at all. Distinct from an endpoint own 404, which means the route exists and the record does not.
 * OpenAPI spec version: 2.0.0
 */

/**
 * * `paid` - Paid
 * * `datalogger` - Has a datalogger
 * * `measurements` - Has measurements
 * * `charges` - Has charges
 * * `password_set` - Set their password
 * * `in_use` - Used outside the conversion
 * * `children` - A child is blocked
 */
export type QuoteConversionBlockerEnum = typeof QuoteConversionBlockerEnum[keyof typeof QuoteConversionBlockerEnum];


export const QuoteConversionBlockerEnum = {
  paid: 'paid',
  datalogger: 'datalogger',
  measurements: 'measurements',
  charges: 'charges',
  password_set: 'password_set',
  in_use: 'in_use',
  children: 'children',
} as const;
